var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"size":"small","resizable":"","border":""}})}
var staticRenderFns = []

export { render, staticRenderFns }